export function header1_viewportEnter(event) 
	{$w("#horizontalMenu1").show();}


export function header1_viewportLeave(event) 
	{$w("#horizontalMenu1").hide();}


export function footer1_viewportEnter(event) 
	{$w("#horizontalMenu1").show();}  


export function footer1_viewportLeave(event) 
	{$w("#horizontalMenu1").hide();} 


